// Notification IDs
export const PTO_PENDING_UPDATE = 'pto-pending-updates-notify'
export const UPDATE_EXM_NOTIFY = 'update-exm-notify'
export const ADD_EXM_NOTIFY = 'add-exm-notify'
export const ADD_EXM_FAILURE_NOTIFY = 'add-exm-failure-notify'
export const SIMULATION_NOTIFY = 'simulation-notify'
export const RESTRICTED_MODULES_NOTIFY = 'restricted-modules-notify'
export const FEATURES_OUTDATED_NOTIFY = 'features-outdated-summary-notify'
export const EDIT_RP_NOTIFY = 'rp-edit-workflow-notify'
export const DUPLICATE_RP_NOTIFY = 'rp-duplicate-workflow-notify'
export const DUPLICATE_MASTER_RP_NOTIFY = 'duplicate-master-rp-32ap1-notify'
export const PREPROD_SWGA_EDIT_NOTIFY = 'preprod-swga-edit-notify'
export const PREPROD_SWGA_EDIT_NOTIFY_NODATE = 'preprod-swga-edit-nodate-notify'
export const SWGA_SETTING_SAVED = 'swga-setting-saved'
export const EDIT_FEATURE_NOTIFY = 'feature-edit-workflow-notify'
export const EDIT_SP_NOTIFY = 'sp-edit-workflow-notify'
export const MULTIPLE_RP_MLOGIC_NOTIFY = 'multiple-rps-with-mlogic-notify'
export const OMAP_VALIDITY_NOTIFY = 'omap-validity-error-notify'
export const SP_SAVED_NOTIFY = 'sp-saved-notify'
export const MULTIPLE_RP_SLOTCOPY_NOTIFY = 'multiple-rps-slotcopy-notify'
export const DISABLE_SP_EDITING_NOTIFY = 'disable-sp-editing'
export const TRUCK_COMPARE_NOTIFY = 'truck-compare-notify'
export const SP_EDITOR_VALIDITY_NOTIFY = 'sp-editor-validity-error'
export const SP_WARNING_SWITCH_NOTIFY = 'sp-warning-switch-notify'
export const VALIDATION_NOTIFY = 'validation-notify'
export const RESOURCE_CONFLICT_NOTIFY = 'resource-conflict-notify'
export const UPDATE_FLEET_SUCCESS_NOTIFY = 'update-fleet-success-notify'
export const UPDATE_FLEET_FAIL_NOTIFY = 'update-fleet-fail-notify'
export const UPDATE_FLEET_PROGRESS_NOTIFY = 'update-fleet-progress-notify'
export const PTO_SAVE_FAIL_NOTIFY = 'pto-save-fail-notify'
export const FEATURE_LOGIC_MERGED = 'feature-logic-merged'
export const ADD_FEATURE_SUCCESS = 'add-feature-success'
export const OPTIONAL_SOLENOIDS_EXCEEDED = 'optional-solenoids-exceeded'
export const ADD_FEATURE_SUCCESS_SNG = 'add-feature-success-sng'
export const ADD_FEATURE_SUCCESS_ECU = 'add-feature-success-ecu'
export const ECP_PENDING_MULTIPLE_UPDATES =
  'ecp-pending-multiple-updates-notify'
export const OPTIONAL_SOLENOIDS_NOT_INSTALLED =
  'optional-solenoids-not-installed-notify'
export const ECP_PENDING_UPDATE = 'ecp-pending-update-notify'
export const SNG_PENDING_UPDATE = 'sng-pending-update-notify'
export const SNG_SAVE_SUCCESS = 'sng-save-success-notify'
export const PAR_FILE_DOWNLOAD_NOTIFY = 'par-file-download-notify'
export const PAR_FILE_ERROR_NOTIFY = 'par-file-error-notify'
export const PTO_SAVE_TEMPLATE_NOTIFY = 'pto-save-template-notify'
export const FEATURE_CREATE_NOTIFY = 'feature-create-notify'
export const PRE_PROD_LOCATION_TYPE_UPDATE = 'pre-pod-location-type-update'
export const PRE_PROD_LOCATION_TYPE_UPDATE_WARNING =
  'pre-prod-location-type-update-warning'
export const ECUS_ADD_XMC_SUCCESS_NOTIFY = 'ecus-add-xmc-success-notify'
export const ECUS_ADD_XMC_WARNING_NOTIFY = 'ecus-add-xmc-warning-notify'
export const ECUS_ADD_XMC_FAILURE_NOTIFY = 'ecus-add-xmc-failure-notify'
export const COMMIT_RP_TO_VEHICLE_ERROR_NOTIFY =
  'commit-rp-vehicle-error-notify'
export const COMMIT_RP_TO_VEHICLE_SUCCESS_NOTIFY =
  'commit-rp-vehicle-success-notify'
export const ECP_ADD_WARNING_NOTIFY = 'ecp-add-warning-notify'
export const PRE_PROD_READ_ONLY_LEAD = 'pre-prod-readonly-lead'
export const PRE_PROD_READ_ONLY_NONLEAD = 'pre-prod-readonly-nonlead'

export const getFragmentId = (description) => {
  if (!description) return null
  const fragmentId = description.split(' ')[0]
  return fragmentId
}

export const getErrorDetail = (description) => {
  if (!description) return null
  const errorDetail = description.split(' ').slice(2).join(' ')
  return errorDetail
}
